
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    url: String,
  },
  computed: {
    shareUrl() {
      return this.url ? this.url : window.location.href;
    },
  },
  data() {
    return {
      menuVisible: false,
      sharing: {
        //description: this.ad.description,
        //quote: "The hot reload is so fast it's near instant. - Evan You",
        //hashtags: 'vuejs,vite,javascript',
        //twitterUser: 'youyuxi',
      },
      networks: [
        { network: 'facebook', name: 'Facebook', icon: 'icon-facebook', color: '#1877f2' },
        //{ network: 'line', name: 'Line', icon: 'fa-line', color: '#00c300' },
        //{ network: 'linkedin', name: 'LinkedIn', icon: 'fa-linkedin', color: '#007bb5' },
        //{ network: 'odnoklassniki', name: 'Odnoklassniki', icon: 'fa-odnoklassniki', color: '#ed812b' },
        //{ network: 'pinterest', name: 'Pinterest', icon: 'fa-pinterest', color: '#bd081c' },
        //{ network: 'reddit', name: 'Reddit', icon: 'fa-reddit-alien', color: '#ff4500' },
        //{ network: 'skype', name: 'Skype', icon: 'fa-skype', color: '#00aff0' },
        //{ network: 'telegram', name: 'Telegram', icon: 'fa-telegram-plane', color: '#0088cc' },
        //{ network: 'twitter', name: 'Twitter', icon: 'fa-twitter', color: '#1da1f2' },
        //{ network: 'viber', name: 'Viber', icon: 'fa-viber', color: '#59267c' },
        //{ network: 'vk', name: 'Vk', icon: 'fa-vk', color: '#4a76a8' },
        //{ network: 'weibo', name: 'Weibo', icon: 'fa-weibo', color: '#e9152d' },
        { network: 'whatsapp', name: 'Whatsapp', icon: 'icon-whatsapp', color: '#25d366' },
        { network: 'email', name: 'Email', icon: 'icon-email', color: '#41b883' },
        //{ network: 'fakeblock', name: 'Custom Network', icon: 'fa-vuejs', color: '#41b883' },
      ],
    };
  },
  methods: {
    onClickOutside() {
      this.menuVisible = false;
    },
  },
});
